// Electron (Windows) drops the renderer's keyboard focus after a NATIVE dialog
// — window.confirm / alert / prompt. The dialog closes, the click that follows
// still works, but the NEXT text input silently ignores typing until the window
// is re-focused. That's why "delete a field (confirm) → Add field → can't type"
// happened in the desktop build.
//
// Fix: after any native dialog returns, restore focus — via the desktop bridge
// (main process webContents.focus(), the reliable path) and window/element
// focus as a fallback. Harmless no-op in a normal browser (no bridge, and
// window.focus is a cheap call). Loaded once at app startup.

function restoreFocus(previouslyFocused) {
  try {
    window.focus();
    // desktop preload exposes this; undefined in the browser.
    if (window.__ubosDesktop && typeof window.__ubosDesktop.refocus === "function") {
      window.__ubosDesktop.refocus();
    }
    if (previouslyFocused && typeof previouslyFocused.focus === "function") {
      previouslyFocused.focus();
    }
  } catch (_) {
    /* best-effort */
  }
}

export function installNativeDialogFocusFix() {
  if (typeof window === "undefined") return;
  ["confirm", "alert", "prompt"].forEach((name) => {
    const original = window[name];
    if (typeof original !== "function" || original.__ubosPatched) return;
    const patched = function (...args) {
      const active = document.activeElement;
      const result = original.apply(window, args);
      restoreFocus(active);
      // and again once the native dialog has fully torn down
      setTimeout(() => restoreFocus(document.activeElement), 0);
      return result;
    };
    patched.__ubosPatched = true;
    window[name] = patched;
  });
}
